import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation, useHistory } from 'react-router-dom';
import previousIcon from '../../../assets/images/arrow-left.png';
import nextIcon from '../../../assets/images/arrow-right.png';
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'react-i18next';
import { getPathLanguage, getQueryString } from '../../../utils/params';
import { getFeaturedProjects } from '../featuredProject.api';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BreadcrumbFeaturedProjects from '../common/Breadcrumb.FeaturedProjects';
import { Location } from '../../../assets/images/web-isn';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { useParams } from 'react-router-dom';

const FeaturedProjectComponent = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const history = useHistory();
  const { t } = useTranslation();
  const pathLanguage = getPathLanguage(useLocation());
  const { language } = useParams();
  const cityId = localStorage.getItem('LOCATION_CITY')
    ? localStorage.getItem('LOCATION_CITY')
    : localStorage.getItem('DEFAULT_CITY');
  const [pageSize, setPageSize] = useState(3);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageCount, setPageCount] = useState();
  const [startItem, setStartItem] = useState(1);
  const [endItem, setEndItem] = useState(3);
  const [listProjects, setListProjects] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    onFetchData();
    //eslint-disable-next-line
  }, [pageIndex, pageSize]);

  const onFetchData = () => {
    try {
      showLoader();
      getFeaturedProjects(getQueryString({ language, pageSize, pageIndex, cityId })).then(res => {
        if (res?.data) {
          setListProjects(res?.data);
          if (res?.data) {
            let changeEndItem = pageSize * pageIndex;
            if (changeEndItem > res?.data.totalRecords) {
              setEndItem(res?.data.totalRecords);
            } else {
              setEndItem(changeEndItem);
            }
          }
          setPageCount(Math.ceil(res?.data?.totalRecords / pageSize));
        }
      });
    } finally {
      hideLoader();
    }
  };

  // Go to detail page
  const goToDetailPage = item => {
    history.push(`${pathLanguage}/featured-projects/detail/overview/${item.id}/${item.slug}`);
  };

  // Change pageSize
  const [forcePage, setForcePage] = useState();
  const handlePageSize = e => {
    let pageSize = e.target.value;
    let newPageSize = parseInt(pageSize);
    setPageSize(newPageSize);
    changePage({ selected: 0 });
    setForcePage(0);
  };

  const changePage = ({ selected }) => {
    setForcePage(selected);
    setPageIndex(selected + 1);
    setStartItem(pageSize * selected + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  const displayItems = () => {
    if (listProjects && listProjects.items) {
      const listFeaturedProjects = listProjects.items;
      return (
        <div className="serviceapartment-page mt-2">
          {listFeaturedProjects.map((item, index) => {
            return (
              <div id="featuredProjects" className="project-cover px-0" key={index}>
                <div className="project-info justify-content-center align-items-center mt-3">
                  <div className="container-slider">
                    <div className="slide" onClick={() => goToDetailPage(item)}>
                      <LazyLoadImage
                        src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`}
                        alt={item.projectName}
                      />
                    </div>
                  </div>
                  <div className="project-card" onClick={() => goToDetailPage(item)}>
                    <div className="content">
                      <div className="projects-name text-truncate-box-title-name">{item.projectName}</div>
                      <div className="location mt-2">
                        <img src={Location} alt="PIN" />
                        <div className="ml-2 text-truncate-box-title-name">Address: {item.address}</div>
                      </div>
                      <div className="project-listing mt-2">
                        {item.quantity}{' '}
                        {item.quantity > 1 ? t('featured_projects_isn.listings') : t('featured_projects_isn.listing')}
                      </div>
                      <div
                        className="project-description mt-3"
                        dangerouslySetInnerHTML={createMarkup(item.content)}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      <div id="featuredProjects">
        <div className="container">
          <div className="mb-3">
            <BreadcrumbFeaturedProjects />
          </div>
          <div className="item-per-page-container px-0 col-12">
            {/* display total item, item count of current page */}
            {listProjects ? (
              <div className="item-count-container">
                <span>&nbsp;</span> {listProjects.totalRecords !== startItem ? `${startItem} - ` : ''}
                {listProjects.totalRecords > listProjects.pageSize ? endItem : listProjects.totalRecords}{' '}
                {t('service_apartment_isn.text_of')} {listProjects.totalRecords} <span>&nbsp;</span>
              </div>
            ) : (
              ''
            )}

            {/* select items display per page */}
            <select className="item-number cursor-pointer" onChange={e => handlePageSize(e)}>
              <option value="3">3</option>
              <option value="6">6</option>
              <option value="9">9</option>
              <option value="12">12</option>
              <option value="15">15</option>
              <option value="18">18</option>
            </select>
          </div>
        </div>

        {/* render apartments list */}
        <div className="container">{displayItems()}</div>

        {/* paginate */}
        {listProjects && listProjects.totalRecords > 3 ? (
          <div className="service-paginate">
            <ReactPaginate
              previousLabel={<LazyLoadImage src={previousIcon} alt="nav-btn" />}
              nextLabel={<LazyLoadImage src={nextIcon} alt="nav-btn" />}
              pageRangeDisplayed={1}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              onPageChange={changePage}
              disabledClassName={'opacity-disable'}
              activeClassName={'pagination-active'}
              pageClassName={'pagination-pager-item'}
              nextLinkClassName={'next-btn'}
              previousLinkClassName={'prev-btn'}
              forcePage={forcePage}
            />
          </div>
        ) : (
          <div className="mt-5"></div>
        )}
      </div>
      {loader}
    </React.Fragment>
  );
};

const mapStatetoProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStatetoProps, mapDispatchToProps)(FeaturedProjectComponent);
